export enum RouteParams {
	DEGREE_TYPE = "degree_type",
	COUNTRY = "country",
	AREA = "area",
	CONTINENT = "continent",
	ATTENDANCE = "attendance",
	DISCIPLINE = "discipline",
	SORT = "sort"
}
